import {
  PublicationStatus,
  Shift,
  TimelineTimeframe,
  WithPreparedAttributes,
} from '@wilson/interfaces';
import { determineShiftRenderDatetime } from '@wilson/non-domain-specific/overlap-helpers';
import { endOfDay, startOfDay } from 'date-fns';

export interface UnreleasedAndDeclineShifts {
  unreleasedShifts: (Shift & WithPreparedAttributes & { id: string })[];
  declinedShifts: (Shift & WithPreparedAttributes & { id: string })[];
}

export function determineUnreleasedAndDeclineShifts(
  assignedShifts: (Shift & WithPreparedAttributes & { id: string })[],
  visibleDateRange: TimelineTimeframe,
  isCellView: boolean,
): UnreleasedAndDeclineShifts {
  const unreleasedShifts: (Shift &
    WithPreparedAttributes & {
      id: string;
    })[] = [];
  const declinedShifts: (Shift &
    WithPreparedAttributes & {
      id: string;
    })[] = [];

  const startVisible = isCellView
    ? startOfDay(new Date(visibleDateRange.start)).getTime()
    : visibleDateRange.start;
  const endVisible = isCellView
    ? endOfDay(new Date(visibleDateRange.end)).getTime()
    : visibleDateRange.end;

  assignedShifts.forEach((shift) => {
    if (
      shift.publicationStatus === PublicationStatus.NotPublished ||
      shift.publicationStatus === PublicationStatus.NotPublishedAgain ||
      shift.declinedAt
    ) {
      const determineShift = determineShiftRenderDatetime(shift, false);
      const startDatetime = new Date(
        determineShift.startDatetime.date,
      ).getTime();

      let isShiftVisible = false;
      if (isCellView) {
        isShiftVisible =
          startDatetime >= startVisible && startDatetime <= endVisible;
      } else {
        const endDatetime = new Date(determineShift.endDatetime.date).getTime();
        isShiftVisible =
          (startDatetime >= startVisible || endDatetime >= startVisible) &&
          (startDatetime <= endVisible || endDatetime <= endVisible);
      }

      if (isShiftVisible) {
        if (
          shift.publicationStatus === PublicationStatus.NotPublished ||
          shift.publicationStatus === PublicationStatus.NotPublishedAgain
        ) {
          unreleasedShifts.push(shift);
        }
        if (shift.declinedAt) {
          declinedShifts.push(shift);
        }
      }
    }
  });

  return {
    unreleasedShifts,
    declinedShifts,
  };
}
